import { ConfigProvider } from "antd";
import React from "react";
import srSR from "antd/lib/locale/sr_RS";
export interface Props {
  router: any;
  children?: any;
}
export interface State {}

export default class RootLayout extends React.Component<Props, State> {
  render() {
    const { children } = this.props;
    return (
      <ConfigProvider locale={srSR}>
        <div className="root_layout">{children}</div>
      </ConfigProvider>
    );
  }
}
